<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="登记日期" prop="date">
            <form-date-range
              :form="searchForm"
              startKey="registerDts"
              endKey="registerDte"
              :usingTime="false"
              valueFormat="yyyy-MM-dd"
            ></form-date-range>
          </el-form-item>
          <el-form-item label="店铺简称" prop="storeCode">
            <el-select v-model="searchForm.storeCode" filterable clearable placeholder="请选择" @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in storeList" :key="item.storeCode" :label="item.storeName" :value="item.storeCode"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客服ID" prop="customerServiceId">
            <el-input v-model.trim="searchForm.customerServiceId" @keyup.enter.native="onSearch" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="是否合格" prop="qualified">
            <el-select v-model="searchForm.qualified" clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option label="是" value="1" />
              <el-option label="否" value="0" />
            </el-select>
          </el-form-item>
          <el-form-item label="质检人" prop="qualityPerson">
            <el-input v-model.trim="searchForm.qualityPerson" @keyup.enter.native="onSearch" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="姓名" prop="userName">
            <el-input v-model.trim="searchForm.userName" @keyup.enter.native="onSearch" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="工号" prop="workNo">
            <el-input v-model.trim="searchForm.workNo" @keyup.enter.native="onSearch" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="是否申诉" prop="appeal">
            <el-select v-model="searchForm.appeal" clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option label="是" value="1" />
              <el-option label="否" value="0" />
            </el-select>
          </el-form-item>
          <el-form-item label="申诉审核状态" prop="appealStatus">
            <el-select v-model="searchForm.appealStatus" clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option :label="item" :value="item" v-for="item in appealStatusList" :key="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="违规条目" prop="checkCategory">
            <el-select v-model="searchForm.checkCategory" clearable filterable @change="handleCheckCategoryChange">
              <el-option v-for="item in checkCategoryList" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="违规项" prop="categoryDetail">
            <el-select v-model="searchForm.categoryDetail" clearable filterable @change="handleCategoryDetailChange">
              <el-option v-for="item in categoryDetailList" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="场景" prop="violation">
            <el-select v-model="searchForm.violation" clearable filterable @change="onSearch">
              <el-option v-for="item in sceneList" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="确认结果" prop="confirmResult">
            <el-select v-model="searchForm.confirmResult" clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option label="待确认" value="0" />
              <el-option label="确认超时" value="1" />
              <el-option label="驳回" value="2" />
              <el-option label="同意" value="3" />
            </el-select>
          </el-form-item>
          <el-form-item label="审核结果" prop="auditResult">
            <el-select v-model="searchForm.auditResult" clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option label="待审核 " value="0" />
              <el-option label="审核超时" value="1" />
              <el-option label="申诉成功" value="2" />
              <el-option label="申诉失败" value="3" />
            </el-select>
          </el-form-item> -->
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="onEdit(null)">新增</el-button>
        <el-button type="primary" size="mini" @click="onImport">导入</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-loading="loading"
      >
        <el-table-column label="质检人" prop="qualityPersonName" min-width="70" show-overflow-tooltip />
        <el-table-column label="年/月" prop="yearMonth" min-width="80" show-overflow-tooltip />
        <el-table-column label="周" prop="week" min-width="65" show-overflow-tooltip />
        <el-table-column label="登记日期" prop="registerDt" min-width="100" show-overflow-tooltip />
        <el-table-column label="会话日期" prop="sessionDt" min-width="100" show-overflow-tooltip />
        <el-table-column label="店铺简称" prop="storeShoreName" min-width="100" show-overflow-tooltip />
        <el-table-column label="店铺全称" prop="storeName" min-width="150" show-overflow-tooltip />
        <el-table-column label="客户ID" prop="customerId" min-width="120" show-overflow-tooltip />
        <el-table-column label="客服ID" prop="customerServiceId" min-width="100" show-overflow-tooltip />
        <el-table-column label="姓名" prop="userName" min-width="80" show-overflow-tooltip />
        <el-table-column label="工号" prop="workNo" min-width="110" show-overflow-tooltip />
        <el-table-column label="岗位" prop="workJobs" min-width="120" show-overflow-tooltip />
        <el-table-column label="客服等级" prop="customerServiceLevel" min-width="80" show-overflow-tooltip />
        <el-table-column label="入职日期" prop="entryDate" min-width="100" />
        <el-table-column label="责任部门" prop="responsibleDepartment" min-width="80" show-overflow-tooltip />
        <el-table-column label="是否合格" prop="qualified" min-width="90" />
        <el-table-column label="质检来源" prop="qualitySource" min-width="100" show-overflow-tooltip />
        <el-table-column label="质检条目" prop="checkCategory" min-width="100" show-overflow-tooltip />
        <el-table-column label="违规项" prop="categoryDetail" min-width="100" show-overflow-tooltip />
        <el-table-column label="场景" prop="violation" min-width="100" show-overflow-tooltip />
        <el-table-column label="问题描述" prop="problemDesc" min-width="200" show-overflow-tooltip />
        <el-table-column label="质检截图" prop="qualityImgList" min-width="80" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" v-if="row.qualityImgList && row.qualityImgList.length" @click="imgShow(row.qualityImgList)">查看</el-button>
            <!-- <el-image
              :src="row.qualityImgList[0]"
              :preview-src-list="row.qualityImgList"
              :initial-index="0"
              fit="cover"
              style="width: 50px; height: 50px; cursor: pointer;"
            >
            </el-image> -->
          </template>
        </el-table-column>
        <el-table-column label="扣分" prop="deductPoints" min-width="60" show-overflow-tooltip />
        <el-table-column label="备注" prop="remark" min-width="200" show-overflow-tooltip />
        <el-table-column label="申诉时效" prop="appealTime" min-width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.appealTime ? row.appealTime + '天' : '' }}
          </template>
        </el-table-column>
        <el-table-column label="是否申诉" prop="appeal" min-width="80" show-overflow-tooltip />
        <el-table-column label="申诉原因" prop="appealReason" min-width="200" show-overflow-tooltip />
        <el-table-column label="申诉材料" prop="appealImgList" min-width="80" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" v-if="row.appealImgList && row.appealImgList.length" @click="imgShow(row.appealImgList)">查看</el-button>
            <!-- <el-image
              v-if="row.appealImgList && row.appealImgList.length"
              :src="row.appealImgList[0]"
              :preview-src-list="row.appealImgList"
              :initial-index="0"
              fit="cover"
              style="width: 50px; height: 50px; cursor: pointer;"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image> -->
          </template>
        </el-table-column>
        <el-table-column label="申诉人" prop="appealUserName" min-width="80" show-overflow-tooltip />
        <el-table-column label="申诉时间" prop="appealDt" min-width="110" show-overflow-tooltip />
        <el-table-column label="申诉审核状态" prop="appealStatus" min-width="110" show-overflow-tooltip />
        <!-- <el-table-column label="确认结果" prop="confirmResult" min-width="90" show-overflow-tooltip/> -->
        <!-- <el-table-column label="确认人" prop="confirmUserName" min-width="80" show-overflow-tooltip/>
        <el-table-column label="确认时间" prop="confirmDt" min-width="160" show-overflow-tooltip/>
        <el-table-column label="审核结果" prop="auditResult" min-width="90" show-overflow-tooltip/>
        <el-table-column label="审核描述" prop="auditReason" min-width="120" show-overflow-tooltip/>
        <el-table-column label="审核人" prop="auditUserName" min-width="80" show-overflow-tooltip/>
        <el-table-column label="审核时间" prop="auditDt" min-width="160" show-overflow-tooltip/> -->
        <el-table-column label="操作" fixed="right" min-width="150" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="onView(row)">查看</el-button>
            <el-button type="text" size="mini" @click="onEdit(row)" style="color: #409eff" v-show="row.showEditBtn">编辑</el-button>
            <el-button type="text" size="mini" @click="onDelete(row)" style="color: #f56c6c" v-show="row.showDelBtn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <el-image ref="imgViewRef" :src="imgList[0]" :preview-src-list="imgList" :initial-index="0" fit="cover" style="width: 100 px; height: 100px; display: none">
    </el-image>
    <!-- 新增编辑 -->
    <edit-dialog
      :visible.sync="isShowEdit"
      v-if="isShowEdit"
      :rowData="rowData"
      :violationQueryList="violationQueryList"
      :sysConfigList="sysConfigList"
      :storeList="storeList"
      @success="onSearch"
    />
    <!-- 查看 -->
    <view-dialog :visible.sync="isShowView" v-if="isShowView" :rowData="rowData" />
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgVisible" v-if="imgVisible" :close-on-click-modal="false" width="50%" v-esc-close
      ><imgShow :imgList="imgList"></imgShow
    ></el-dialog>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';
import imgShow from '@/views/components/imgShow';
import viewDialog from './components/view.vue';
import editDialog from './components/edit.vue';
import axios from '@/utils/axiosInstance';

export default {
  name: 'photographySalaryAccounting',
  mixins: [tableMixin, pagePathMixin],
  components: { imgShow, editDialog, viewDialog },
  data() {
    return {
      loading: false,
      imgVisible: false,
      isShowEdit: false,
      isShowView: false,
      isShowImg: false,
      imgList: [],
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      searchFormData: [],
      rules: {},
      rowData: {},
      reportName: 'newProductPictureRetouchDetailInfo',
      columnData: [],
      loading: false,
      searchForm: {
        registerDts: '',
        registerDte: '',
        storeCode: '',
        customerServiceId: '',
        qualified: '',
        qualityPerson: '',
        userName: '',
        workNo: '',
        appeal: '',
        confirmResult: '',
        auditResult: '',
        appealStatus: '',
        checkCategory: '',
        categoryDetail: '',
        violation: '',
      },
      exportData: {},
      searchCollapse: false,
      queryCriteria: [],
      spuCategoryList: [],
      goodsLocationList: [],
      storeList: [],
      violationQueryList: [],
      sysConfigList: [],
      sysConfigList: [],
      appealStatusList: [],
      checkCategoryList: [],
      categoryDetailList: [],
      sceneList: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        hasCount: 'N',
      },
    };
  },
  computed: {},
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
      this.queryAppealStatus();
    },
    async init() {
      this.loading = true;
      let { workNo } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          workNo: workNo ? workNo.toUpperCase() : '',
          type: 1,
        },
      };
      this.searchFormData = data;
      this.$q.qualityTestingManage
        .registerPage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onEdit(row) {
      this.rowData = row ? { ...row } : row;
      this.isShowEdit = true;
    },

    // 查看图片
    viewImg(list) {
      this.imgVisible = true;
      this.imgList = list;
    },
    //获取申诉原因
    queryAppealStatus() {
      this.$q.qualityTestingManage.queryAppealStatus().then((res) => {
        this.appealStatusList = res.data;
      });
    },

    //店铺
    getUserStoreList() {
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = 'storeInfoList';
      axios.post(`/ec-pc-api/custom/reports/data/storeInfoList`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.storeList = res.data.list;
        }
      });
    },
    //场景
    getViolationQuery() {
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = 'violationQuery';
      axios.post(`/ec-pc-api/custom/reports/data/violationQuery`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.violationQueryList = res.data.list;
        }
      });
    },
    //质检来源
    getSysConfig() {
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = 'sysConfig';
      currencyForm.param = {
        confCode: 'quality_source',
      };
      axios.post(`/ec-pc-api/custom/reports/data/sysConfig`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.sysConfigList = res.data.list;
        }
      });
    },
    imgShow(imgList) {
      this.imgList = [];
      this.imgList = imgList;
      setTimeout((_) => {
        this.$refs.imgViewRef.$el.children[0].click();
      }, 500);
    },

    // 查看详情
    onView(row) {
      this.rowData = { ...row };
      this.isShowView = true;
    },

    // 删除
    async onDelete(row) {
      let status = await this.$confirm('确认要删除该信息吗？', '提示', { type: 'warning' });
      if (status !== 'confirm') return;
      const formData = new FormData();
      formData.append('qualityNo', row.qualityNo);
      this.$q.qualityTestingManage.registerDel({ data: formData }).then((res) => {
        if (res.code == 200) {
          this.$message.success('删除成功');
          this.init();
        }
      });
    },

    // 导入
    onImport() {
      this.openSubPage({
        path: '/qualityTestingRegisterImport',
        query: {
          fileName: '质检登记导入.xlsx',
          appCode: 'ec-pc-new',
          reportName: 'QualityRegisterImport',
        },
      });
    },

    // 导出
    exportExcel() {
      console.log(this.searchFormData);
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'qualityRegisterExport',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取违规配置项 type 1：违规条目 2：违规项 3：场景
    getQualityConfigItem(type) {
      let data = {
        type: type,
        checkCategory: this.searchForm.checkCategory,
        categoryDetail: this.searchForm.categoryDetail,
      };
      return this.$q.qualityTestingManage.queryQualityConfigItem({ data }).then((res) => {
        if (res.success) {
          return res.data || [];
        }
        return [];
      });
    },
    // 获取违规条目列表
    getCheckCategoryList() {
      this.getQualityConfigItem(1).then((list) => {
        this.checkCategoryList = list;
      });
    },
    // 违规条目改变
    handleCheckCategoryChange() {
      this.searchForm.categoryDetail = '';
      this.searchForm.violation = '';
      this.categoryDetailList = [];
      this.sceneList = [];
      this.onSearch();
      if (this.searchForm.checkCategory) {
        this.getQualityConfigItem(2).then((list) => {
          this.categoryDetailList = list;
        });
      }
    },
    // 违规项改变
    handleCategoryDetailChange() {
      this.searchForm.violation = '';
      this.sceneList = [];
      this.onSearch();
      if (this.searchForm.categoryDetail) {
        this.getQualityConfigItem(3).then((list) => {
          this.sceneList = list;
        });
      }
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
  mounted() {
    let params = this.$route.params;
    if (params.qualityPersonName) {
      this.rowData = params;
      setTimeout(() => {
        this.isShowEdit = true;
      }, 500);
    }
    this.onSearch();
    this.getUserStoreList();
    this.getViolationQuery();
    this.getSysConfig();
    this.getCheckCategoryList();
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

work
  position: absolute
  top: 0
  left: 0
</style>
